import { defaultProps } from 'recompose';

import ErrorMessage from '@/components/ErrorMessages/ErrorMessage';

import Icon from './icon.svg';

export default defaultProps({ Icon })(ErrorMessage);
